/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Label } from 'semantic-ui-react';
import deleteIcon from '../../images/components/contnets_header/delete-icon-red.svg';
import searchIcon from '../../images/components/contnets_header/searchIcon.png';

class SettingContentsHeaderByGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errSearch: false,
      isFocus: false,
      isExpand: props.isExpand,
      isPageLoading: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleTableTree = this.handleTableTree.bind(this);
    this.addNewGroup = this.addNewGroup.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    const { isExpand, state } = this.props;

    if (isExpand !== prevProps.isExpand) {
      this.setState({
        isExpand,
      });
    }

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      state.user.getsGroupCount();
      this.setState({
        isPageLoading: false,
      });
    }
  }

  handleSearch(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      setTimeout(() => {
        this.setState({
          isFocus: false,
        });
      }, 1500);
      this.props.onChangeSearch(event.target.value);
    }
  }

  handleFocus() {
    this.setState({
      isFocus: true,
    });
  }

  handleBlur() {
    this.setState({
      isFocus: false,
    });
  }

  handleTableTree() {
    this.props.handleTableTree();
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  deleteBtn = () => {
    const { translate } = this.props;
    return (
      <a
        className="delete_button util_button"
        onClick={this.props.deleteGroup}
        style={{ cursor: 'pointer' }}
      >
        <span>
          <img src={deleteIcon} alt="" style={{ width: '12px' }} />
        </span>
        {translate('modal.button.delete')}
      </a>
    );
  };

  addNewGroup() {
    this.props.addNewGroup();
  }

  clearSearch() {
    this.search.value = '';
    this.props.clearSearch();
  }

  render() {
    const { errSearch, isFocus } = this.state;
    const { state, translate } = this.props;
    const { localGroupCount, ldapGroupCount } = toJS(state.user.groupsCount);
    const activeStyle = {
      borderBottom: '2px solid #7434fe',
      color: '#7434fe',
    };

    return (
      <div className="contents_header group">
        <div className="contents_header_inner">
          <div className="contents_tab">
            <NavLink
              style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
              to="/settings/groups/local"
            >
              {translate('settings.list.local_group')}
              <em>{localGroupCount && localGroupCount}</em>
            </NavLink>
            <NavLink
              style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
              to="/settings/groups/ldap"
              end
            >
              {translate('settings.list.ldap_group')}
              <em>{ldapGroupCount && ldapGroupCount}</em>
            </NavLink>
          </div>
          <div className="util_wrap">
            <div className="util_item ">
              <div className="search_files_wrap">
                <img src={searchIcon} alt="" className="icon" />
                <input
                  type="search_files"
                  className="seach_text"
                  placeholder={translate('system.list.group_name')}
                  ref={(ref) => {
                    this.search = ref;
                  }}
                  onKeyPress={this.handleSearch}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                />
                <a className="reset_icon" onClick={this.clearSearch}>
                  x
                </a>
                {errSearch && (
                  <Label basic color="red" pointing>
                    {translate('contents_header.message.least_two_required_to_search')}
                  </Label>
                )}
                {isFocus && <Label pointing>{translate('system.list.group_name')}</Label>}
              </div>
            </div>
            {this.props.location.indexOf('ldap') === -1 && state.user.isAdminOnly && (
              <div className="button_wrap util_item">
                {this.deleteBtn()}
                <a
                  className="add_button util_button"
                  onClick={this.addNewGroup}
                  style={{ cursor: 'pointer' }}
                >
                  <span>+</span>
                  {' '}
                  {translate('modal.button.add')}
                </a>
              </div>
            )}
            {this.props.location.indexOf('ldap') > -1 && (
              <div className="button_wrap util_item">
                <a
                  className="gray_button util_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleTableTree}
                >
                  {this.state.isExpand ? translate('settings.button.expand_all') : translate('settings.button.collapse_all')}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default inject('state')(observer(SettingContentsHeaderByGroups));
